<template>
<ul class="nav-list d-xl-flex justify-content-center align-content-center mb-0">
    <li class="nav-list-it" v-for="item in list" :key="item.id">
        <navbar-dropdown :title="item.title" :link="item.link" :hasChild="item.list.length > 0" :list="item.list"></navbar-dropdown>
    </li>
</ul>
</template>

<script>
import navbarDropdown from '@/components/NavbarDropdown/NavbarDropdown.vue'
export default {
    components: {
        navbarDropdown
    },
    props: {
        list: {
            type: Array,
            required: true
        }
    },
}
</script>

<style src="./TheNavbarList.css" scoped>

</style>
